if (!customElements.get('sticky-cta-quantity')) {
  customElements.define(
    'sticky-cta-quantity',
    class StickyCtaQuantity extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.quantity__input');

        // When this input already carries name="quantity" it IS the real
        // field submitted with the product form, so there is nothing to sync.
        if (!this.input || this.input.hasAttribute('name')) return;

        this.mainInput = this.findMainInput();
        if (!this.mainInput) return;

        this.input.value = this.mainInput.value;

        this.onLocalChange = () => this.sync(this.input, this.mainInput);
        this.onMainChange = () => this.sync(this.mainInput, this.input);

        this.input.addEventListener('change', this.onLocalChange);
        this.mainInput.addEventListener('change', this.onMainChange);
      }

      disconnectedCallback() {
        this.input?.removeEventListener('change', this.onLocalChange);
        this.mainInput?.removeEventListener('change', this.onMainChange);
      }

      findMainInput() {
        const formId = this.dataset.formId;
        if (!formId) return null;
        return document.querySelector(
          `input.quantity__input[name="quantity"][form="${formId}"]`
        );
      }

      sync(source, target) {
        if (!target || target.value === source.value) return;
        target.value = source.value;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );
}

if (!window.initStickyCtaVisibility) {
  window.initStickyCtaVisibility = (root = document) => {
    root.querySelectorAll('.sticky-cta:not([data-visibility-ready])').forEach((stickyCta) => {
      const productInfo = stickyCta.closest('product-info');
      if (!productInfo) return;

      stickyCta.dataset.visibilityReady = 'true';

      const updateVisibility = () => {
        const buyBox = stickyCta._observedBuyBox;
        stickyCta.classList.toggle(
          'is-visible',
          Boolean(buyBox && buyBox.isConnected && buyBox.getBoundingClientRect().bottom <= 0)
        );
      };

      const scheduleVisibilityUpdate = () => {
        if (stickyCta._visibilityFrame) return;
        stickyCta._visibilityFrame = requestAnimationFrame(() => {
          stickyCta._visibilityFrame = null;
          updateVisibility();
        });
      };

      const bindBuyBox = () => {
        const buyBox = productInfo.querySelector('.product-form--buy-buttons');
        if (!buyBox || buyBox === stickyCta._observedBuyBox) return;

        stickyCta._visibilityObserver?.disconnect();
        stickyCta._observedBuyBox = buyBox;
        stickyCta._visibilityObserver = new IntersectionObserver(scheduleVisibilityUpdate, { threshold: 0.01 });
        stickyCta._visibilityObserver.observe(buyBox);
        updateVisibility();
      };

      bindBuyBox();
      window.addEventListener('scroll', scheduleVisibilityUpdate, { passive: true });
      window.addEventListener('resize', scheduleVisibilityUpdate, { passive: true });
      stickyCta._buyBoxMutationObserver = new MutationObserver(bindBuyBox);
      stickyCta._buyBoxMutationObserver.observe(productInfo, { childList: true, subtree: true });

      if (stickyCta.classList.contains('sticky-cta--select-options')) {
        const button = stickyCta.querySelector('.sticky-cta__button .button');
        button?.addEventListener('click', (event) => {
          event.preventDefault();
          const options = productInfo.querySelector(
            'variant-selects, custom-quantity-swatch, .product-form--buy-buttons'
          );
          options?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.initStickyCtaVisibility());
  } else {
    window.initStickyCtaVisibility();
  }

  document.addEventListener('shopify:section:load', (event) => window.initStickyCtaVisibility(event.target));
}
